import { Autocomplete, AutocompleteProps, CircularProgress, TextField } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type PropsType<TField extends FieldValues> = {
	control: Control<TField>;
	name: Path<TField>;
	label?: string;
};

export default function RHFAutoComplete<TField extends FieldValues, T, Multiple extends boolean | undefined, DisableClearable extends boolean | undefined, FreeSolo extends boolean | undefined, ChipComponent extends React.ElementType = 'div'>({ control, name, ...props }: Omit<AutocompleteProps<T, Multiple, DisableClearable, FreeSolo, ChipComponent>, 'renderInput'> & PropsType<TField>) {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { value, onChange }, fieldState: { error } }) => (
				<Autocomplete
					value={value}
					{...props}
					onChange={(_: any, newValue) => {
						onChange(newValue !== null ? newValue : undefined);
					}}
					renderInput={params => (
						<TextField
							error={!!error}
							helperText={error?.message}
							{...params}
							label={props.label}
							InputProps={{
								...params.InputProps,
								endAdornment: (
									<>
										{props.loading ? <CircularProgress color="inherit" size={20} /> : null}
										{params.InputProps.endAdornment}
									</>
								),
							}}
						/>
					)}
				/>
			)}
		/>
	);
}
